import React, { useEffect, useRef } from 'react';
import { animate, stagger } from 'animejs';
import './Values.css';

const Values = () => {
  const bannersRef = useRef(null);

  const navigateToPage = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const values = [
    {
      id: 1,
      title: 'Tienda Natural',
      tag: 'PRODUCTOS CON PROPÓSITO',
      description: 'Superalimentos, frutos secos, especias y combos saludables. Todo seleccionado con intención, enviado a toda Colombia.',
      image: '/images/tienda-carousel-cafe-kaaba.png',
      cta: 'Ver tienda',
      link: '/tienda?category=productos-naturales'
    },
    {
      id: 2,
      title: 'Growth Partner',
      tag: 'ECOSISTEMA DIGITAL',
      description: 'Diseñamos y operamos ecosistemas digitales para marcas que quieren crecer con datos, estrategia y resultados medibles.',
      image: '/images/pillar-comunidad.png',
      cta: 'Conocer más',
      link: '/growth-partner'
    },
    {
      id: 3,
      title: 'Conecta tu camino',
      tag: 'COACHING ONLINE',
      description: 'Programa de 7 sesiones para clarificar tu propósito, tomar decisiones con claridad y vivir con más intención.',
      image: '/images/pillar-bienestar.png',
      cta: 'Primera sesión',
      link: '/bienestar#programa-conecta'
    }
  ];

  /* ── Scroll reveal con Anime.js ── */
  useEffect(() => {
    const container = bannersRef.current;
    if (!container) return;

    const banners = container.querySelectorAll('.value-banner');

    /* Estado inicial: oculto y desplazado */
    banners.forEach((b) => {
      b.style.opacity   = '0';
      b.style.transform = 'translateY(48px) scale(0.97)';
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          animate(banners, {
            opacity   : [0, 1],
            translateY: [48, 0],
            scale     : [0.97, 1],
            delay     : stagger(130),
            duration  : 700,
            ease      : 'outExpo',
          });

          observer.disconnect();
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="values values-banner" id="valores">
      <div className="values-banners" ref={bannersRef}>
        {values.map((value) => (
          <div
            key={value.id}
            className="value-banner"
            onClick={() => navigateToPage(value.link)}
          >
            <img src={value.image} alt={value.title} />
            <div className="value-banner-overlay">
              <span className="value-tag">{value.tag}</span>
              <h3 className="value-headline">{value.title}</h3>
              <p className="value-desc">{value.description}</p>
              <button
                className="value-cta"
                onClick={(e) => { e.stopPropagation(); navigateToPage(value.link); }}
              >
                {value.cta}
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Values;
